import { GroupuiButton } from '@group-ui/group-ui-react';
import type { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ErrorLayout } from '@/app/layouts/error-layout.tsx';

/**
 * Component that renders a generic error message and enables to user to reload the current page using a button.
 * This component is used for main pages and features a ErrorLayout.
 * @returns {ReactNode} Returns a React element which renders an error message and reload button.
 */
export function MainErrorFallback(): ReactNode {
  const { t } = useTranslation();

  return (
    <ErrorLayout
      headline={
        <Trans t={t} i18nKey='error.general.heading'>
          Ooops, something went wrong :(
        </Trans>
      }
      message={
        <Trans t={t} i18nKey='error.general.message'>
          A critical error has occurred. Please try to reload the application.
          <br />
          If the error persists, please contact support.
        </Trans>
      }
    >
      <GroupuiButton
        className='mt-400'
        onClick={() => window.location.assign(window.location.origin)}
      >
        <Trans t={t} i18nKey='error.general.actions.reload'>
          Reload
        </Trans>
      </GroupuiButton>
    </ErrorLayout>
  );
}
